export const MapContainer = (props) => {
    return (
        <div className='map-container container-fluid-boss'>
            <div className='row'>
                <div className='container-row'>
                    <img className='popup-map' alt='map' src={props.link}></img>
                </div>
            </div>
        </div>
    )
}